export default __webpack_public_path__ + "static/media/life.f46557d1.jpg";